import './instrumentation'
import {
    CssBaseline,
    ThemeProvider as MuiThemeProvider,
    StyledEngineProvider,
} from '@mui/material'
import { useThemeStore } from 'global/components/ToggleTheme'
import GlobalStyles from 'global/styles/global'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import getTheme from './global/styles/theme'
import './tailwind.css'

function ThemeProvider({ children }: { children: React.ReactNode }) {
    const mode = useThemeStore(state => state.theme)
    const theme = getTheme(mode)

    return (
        <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </MuiThemeProvider>
        </StyledEngineProvider>
    )
}

function RootApplication() {
    return (
        <React.StrictMode>
            <GlobalStyles />
            <ThemeProvider>
                <App />
            </ThemeProvider>
        </React.StrictMode>
    )
}

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<RootApplication />)
